import date from 'locutus/php/datetime/date'
import strftime from 'locutus/php/datetime/strftime';

export default class Day {
  constructor (timestamp) {
    this.display = date('d', timestamp)
    this.raw = date('Y-m-d', timestamp)
    this.timestamp = timestamp

    this.weekday = strftime('%a', timestamp)
  }
}

//export { Day }